import React from "react"
import {Button} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";

interface BackButtonProps {
    disabled?: boolean
    onBack: () => void
}

const BackButton = ({ disabled = false, onBack }: BackButtonProps) => {
    return (
        <Button
            aria-label="close"
            variant="contained"
            color="secondary"
            size="small"
            className="buttonNarrow"
            onClick={onBack}
            disabled={disabled}
        >
            <ArrowBack fontSize="large"/>
        </Button>
    )
}

export default BackButton
